// Servicio de autenticación (A3).
import { http } from '@/services/http';

/**
 * POST /login. Devuelve la respuesta cruda (token, refresh_token, user…).
 * El guardado de sesión lo hace la vista (session.setSession).
 */
export function login(credentials) {
  return http.post('/login', credentials);
}

/** POST /logout — revocación best-effort del refresh token. */
export function logout(refreshToken) {
  return http.post('/logout', { refresh_token: refreshToken });
}

/** POST /password/request — solicitud de recuperación de contraseña. */
export function requestPasswordReset(email) {
  return http.post('/password/request', { email });
}

/** POST /password/reset — confirmación de recuperación (si el backend la soporta). */
export function resetPassword(payload) {
  return http.post('/password/reset', payload);
}